import { getMatchingRoute, MatchedRoute, MismatchedRoute } from '../routes'
import { getElementTiming, getCustomElementTiming } from './elementTiming'
import { getLCP, LcpEvent } from './getLCP'
import { getRouteExpectations, RouteExpectation } from './getRouteExpectations'
import { Metric } from 'web-vitals'

export interface PageLoadMetrics {
  lcp: LcpEvent | undefined
  elementTiming: Metric | undefined
  customElementTiming: Metric | undefined
}

type Source = keyof PageLoadMetrics

export interface PageLoadContext {
  route: MatchedRoute | MismatchedRoute
  routeExpectations: RouteExpectation
}

export interface PageLoadPayload extends PageLoadMetrics, PageLoadContext {}

export type PageLoadHandler = (payload: PageLoadPayload, source: Source) => void

export const getPageLoadMetrics = (
  onMetricsUpdate: PageLoadHandler,
  pathname: string
) => {
  const route = getMatchingRoute(pathname)
  const routeExpectations = getRouteExpectations(route)

  const metrics: PageLoadPayload = {
    route,
    routeExpectations,
    elementTiming: undefined,
    lcp: undefined,
    customElementTiming: undefined,
  }

  if (routeExpectations.element) {
    getElementTiming(metric => {
      const source: Source = 'elementTiming'
      metrics.elementTiming = metric
      onMetricsUpdate(metrics, source)
    }, routeExpectations.element)

    getCustomElementTiming(metric => {
      const source: Source = 'customElementTiming'
      metrics.customElementTiming = metric
      onMetricsUpdate(metrics, source)
    }, routeExpectations.element)
  }

  getLCP(event => {
    const source: Source = 'lcp'
    metrics.lcp = event
    onMetricsUpdate(metrics, source)
  }, routeExpectations.operations)
}
